module.exports = __webpack_public_path__ + "media/bootstrap-icons/earbuds-e3be3d22.svg";